import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, Pagination } from 'common/components/layout';
import {
  concatUrlString,
  pageFromQuery,
  urlPushQuery,
  queryStringFromProps
} from 'common/helpers/searchHelper';
import SubMenu from 'profile/common/SubMenu';
import {
  listReservations,
  resetReservationQuery
} from 'redux/reservations/actions';

import ReservationList from './components/ReservationList';

class ReservationHistoryList extends Component {
  componentDidMount() {
    const { props } = this;
    props.resetReservationQuery();
    const urlString = queryStringFromProps(props);
    props.listReservations(urlString);
  }

  search = (page) => {
    const { props } = this;
    props.resetReservationQuery();
    const urlString = concatUrlString(page);
    props.listReservations(urlString);
    props.history.push(urlPushQuery('/profile/reservation', urlString));
  };

  render() {
    const { reservations, location, settings } = this.props;
    const page = pageFromQuery(location.search);

    if (!settings.data || !reservations.data || reservations.query === null) {
      return (
        <Layout title="Reservations" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }

    return (
      <Layout title="Reservations">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__order-history">
          <h2>Reservations</h2>
          <ReservationList
            query={reservations.query}
            reservations={reservations.data}
            settings={settings}
          />
          <Pagination
            totalRecords={reservations.recordCount}
            page={page || 1}
            search={this.search}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  reservations: state.reservation,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listReservations,
  resetReservationQuery
})(ReservationHistoryList);
